( function ( $, window ) {
	$( function () {

		var path;

		if ( 'rb' in window ) {
			path = window.rb.iconSpritePath;
		} else {
			path = rb.iconSpritePath;
		}

		( function ( url ) {
			const id = 'svg-sprite';
			const className = 'u-visually-hidden';
			const body = document.body;
			let xhr = new XMLHttpRequest();
			let container;

			if ( 'withCredentials' in xhr ) {
				xhr.withCredentials;
				xhr.open( 'GET', url, true );
			} else if ( typeof XDomainRequest != 'undefined' ) {
				xhr = new XDomainRequest();
				xhr.open( 'GET', url );
			} else {
				body.className += ' no-svg-sprite';
				return;
			}

			xhr.onload = function () {
				container = document.createElement( 'div' );
				container.id = id;
				container.className = className;
				container.innerHTML = xhr.responseText;

				body.insertBefore( container, body.childNodes[0] );
			};

			xhr.onerror = function () {
				body.className += ' no-svg-sprite';
			};

			setTimeout( function () {
				xhr.send();
			}, 0 );
		} )( `${path}/images/icon-sprite.svg` );

	} );
} )( jQuery, window );
